import React from 'react'
import {Helmet} from 'react-helmet'
import {GraphQLProvider} from 'modules/common/utils/GraphQLContext'
import UserProvider from 'modules/auth/utils/UserProvider'
import {SessionProvider as PrimerSessionProvider} from 'modules/primer/context'
import {PartnersProvider} from 'modules/common/utils/PartnersContext'

import ErrorBoundary from 'modules/common/Errors/ErrorBoundary'
import Routes from './routes'

function App() {
  return (
    <>
      <Helmet titleTemplate="%s | Construyo" defaultTitle="Construyo" />
      <GraphQLProvider>
        <UserProvider>
          <PrimerSessionProvider>
            <PartnersProvider>
              <ErrorBoundary>
                <Routes />
              </ErrorBoundary>
            </PartnersProvider>
          </PrimerSessionProvider>
        </UserProvider>
      </GraphQLProvider>
    </>
  )
}

export default App
